import React from 'react'
import View from './view'

const GovCareRegistration = ({gov_care_registration}) => {
  const {
    attributes
  } = gov_care_registration

  return (
    <div className="details-card">
      <h2>Service Provider</h2>
      <View {...attributes}/>
    </div>
  )
}

export default GovCareRegistration


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/gov-care-registration/index.jsx